var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m32 5c0-2.76142-2.2386-5-5-5h-22c-2.76142 0-5 2.23858-5 5v22c0 2.7614 2.23858 5 5 5h22c2.7614 0 5-2.2386 5-5z",
    fill: "#4a154b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m11.3758 18.1146c0 .93-.7516 1.6816-1.68158 1.6816-.92993 0-1.68152-.7516-1.68152-1.6816 0-.9299.75159-1.6815 1.68152-1.6815h1.68158z",
    fill: "#e01e5a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m12.2168 18.1147c0-.9299.7516-1.6815 1.6815-1.6815.93 0 1.6816.7516 1.6816 1.6815v4.2038c0 .93-.7516 1.6815-1.6816 1.6815-.9299 0-1.6815-.7515-1.6815-1.6815z",
    fill: "#e01e5a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m13.8983 11.3631c-.9299 0-1.6815-.7516-1.6815-1.68157 0-.92994.7516-1.68153 1.6815-1.68153.93 0 1.6816.75159 1.6816 1.68153v1.68157z",
    fill: "#36c5f0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m13.8981 12.2166c.9299 0 1.6815.7515 1.6815 1.6815 0 .9299-.7516 1.6815-1.6815 1.6815h-4.21657c-.92994 0-1.68153-.7516-1.68153-1.6815 0-.93.75159-1.6815 1.68153-1.6815z",
    fill: "#36c5f0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m20.6372 13.8981c0-.93.7516-1.6815 1.6815-1.6815.93 0 1.6816.7515 1.6816 1.6815 0 .9299-.7516 1.6815-1.6816 1.6815h-1.6815z",
    fill: "#2eb67d"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m19.7962 13.8981c0 .9299-.7516 1.6815-1.6816 1.6815-.9299 0-1.6815-.7516-1.6815-1.6815v-4.21657c0-.92994.7516-1.68153 1.6815-1.68153.93 0 1.6816.75159 1.6816 1.68153z",
    fill: "#2eb67d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ecb22e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.1146 20.637c.93 0 1.6816.7516 1.6816 1.6815s-.7516 1.6815-1.6816 1.6815c-.9299 0-1.6815-.7516-1.6815-1.6815v-1.6815z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.1146 19.7962c-.9299 0-1.6815-.7516-1.6815-1.6816 0-.9299.7516-1.6815 1.6815-1.6815h4.2166c.9299 0 1.6815.7516 1.6815 1.6815 0 .93-.7516 1.6816-1.6815 1.6816z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/slack.8c3048db0200c200e95f454b37cd7e07.svg";
export { ForwardRef as ReactComponent };